(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-section"] && !Shopify.designMode) return;
  try {
    
const bootstrap = window.bootstrap || {};
document.addEventListener('DOMContentLoaded', function() {
  const state = {
    activeFilters: {
      sizes: new Set(),
      colors: new Set(),
      categories: new Set()
    },
    maxPrice: null,
    loading: false
  };

  // Initialize Bootstrap components
  initializeBootstrapComponents();
  
  // Initialize filters
  initializeFilters();
  
  // Initialize price slider
  initializePriceSlider();

  function initializeBootstrapComponents() {
    document.querySelectorAll('.collapse').forEach(collapseEl => {
      new bootstrap.Collapse(collapseEl, { toggle: false });
    });

    document.querySelectorAll('[data-toggle="collapse"]').forEach(btn => {
      btn.addEventListener('click', handleCollapse);
    });
  }

  function initializeFilters() {
    document.querySelectorAll('.filter_button').forEach(button => {
      button.addEventListener('click', handleFilterClick);
    });
  }

  function initializePriceSlider() {
    const priceSlider = document.getElementById('priceControlRange');
    if (!priceSlider) return;

    state.maxPrice = parseFloat(priceSlider.value);
    
    priceSlider.addEventListener('input', debounce(handlePriceChange, 200));
  }

  function handleFilterClick(event) {
    const button = event.currentTarget;
    const param = button.dataset.param;
    const value = button.value;

    button.classList.toggle('active');
    
    if (button.classList.contains('active')) {
      state.activeFilters[param].add(value);
    } else {
      state.activeFilters[param].delete(value);
    }

    updateUI();
  }

  function handlePriceChange(event) {
    state.maxPrice = parseFloat(event.target.value);
    updatePriceDisplay(state.maxPrice);
    updateUI();
  }

  function updateUI() {
    if (state.loading) return;
    state.loading = true;

    // Add loading class
    document.getElementById('collectionProducts').classList.add('loading');

    // Update filters display
    updateFilterCriteria();
    
    // Filter products
    const hasVisibleProducts = filterProducts();
    
    // Show/hide no products message
    toggleNoProductsMessage(!hasVisibleProducts);

    // Remove loading class
    document.getElementById('collectionProducts').classList.remove('loading');
    state.loading = false;
  }

  function updateFilterCriteria() {
    const filterCriteria = document.getElementById('filter_Criteria');
    let html = '';

    // Build filter tags HTML
    for (const [param, values] of Object.entries(state.activeFilters)) {
      values.forEach(value => {
        html += `
          <div class="filter-tag">
            <span class="badge badge-light">
              ${param}: ${value}
              <button class="btn btn-sm p-0 ml-1" onclick="removeFilter('${param}', '${value}')">×</button>
            </span>
          </div>`;
      });
    }

    filterCriteria.innerHTML = html;
  }

  // Utility functions
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Expose necessary functions globally
  window.resetFilters = function() {
    state.activeFilters = {
      sizes: new Set(),
      colors: new Set(),
      categories: new Set()
    };
    
    document.querySelectorAll('.filter_button.active').forEach(button => {
      button.classList.remove('active');
    });
    
    const priceSlider = document.getElementById('priceControlRange');
    if (priceSlider) {
      priceSlider.value = priceSlider.max;
      state.maxPrice = parseFloat(priceSlider.max);
      updatePriceDisplay(state.maxPrice);
    }
    
    updateUI();
  };

  window.removeFilter = function(param, value) {
    state.activeFilters[param].delete(value);
    const button = document.querySelector(`.filter_button[data-param="${param}"][value="${value}"]`);
    if (button) {
      button.classList.remove('active');
    }
    updateUI();
  };

  function filterProducts() {
    const products = document.querySelectorAll('.collection-product');
    const maxPrice = state.maxPrice;
    const activeFilters = state.activeFilters;

    products.forEach(product => {
      const price = parseFloat(product.dataset.price);
      const sizes = product.dataset.sizes.split('|').filter(Boolean);
      const colors = product.dataset.colors.split('|').filter(Boolean);
      const type = product.dataset.type;

      const priceMatch = price <= maxPrice;
      const sizeMatch = activeFilters.sizes.size === 0 || 
                       sizes.some(size => activeFilters.sizes.has(size));
      const colorMatch = activeFilters.colors.size === 0 || 
                        colors.some(color => activeFilters.colors.has(color));
      const typeMatch = activeFilters.categories.size === 0 || 
                       activeFilters.categories.has(type);

      product.style.display = (priceMatch && sizeMatch && colorMatch && typeMatch) ? '' : 'none';
    });

    return products.some(product => product.style.display === '');
  }

  function updatePriceDisplay(maxPrice) {
    const priceIndicator = document.getElementById('maximum_price_indicator');
    const priceCriteria = document.getElementById('price_Criteria');
    
    if (priceIndicator && priceCriteria) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      
      priceIndicator.textContent = formatter.format(maxPrice);
      priceCriteria.textContent = formatter.format(maxPrice);
    }
  }

  function toggleNoProductsMessage(show) {
    const noProductsMessage = document.getElementById('noProductsMessage');
    if (noProductsMessage) {
      noProductsMessage.classList.toggle('d-none', show);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-gallery"] && !Shopify.designMode) return;
  try {
    
class ProductGalleryMobile {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('[data-slider]');
    this.images = container.querySelectorAll('.gallery-image-wrapper');
    this.prevButton = container.querySelector('[data-nav="prev"]');
    this.nextButton = container.querySelector('[data-nav="next"]');
    
    // Store variant data
    this.variantData = JSON.parse(document.querySelector('variant-selects script').textContent);
    
    // Initialize with a slight delay to ensure DOM is ready
    setTimeout(() => {
      // Hide all images initially
      this.images.forEach(image => {
        image.style.display = 'none';
      });

      // Get initial color and update images
      const initialColor = document.querySelector('input[name="Color"]:checked')?.value;
      if (initialColor) {
        this.updateImagesForColor(initialColor.toLowerCase(), true);
      }
    }, 100);
    
    // Initialize observers and listeners
    this.initColorChangeListener();
    this.initMutationObserver();
  }

  initMutationObserver() {
    // Watch for changes in variant selects
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            const color = document.querySelector('input[name="Color"]:checked')?.value;
            if (color) {
              this.updateImagesForColor(color.toLowerCase());
            }
          }
        });
      });

      observer.observe(variantSelects, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }

  initColorChangeListener() {
    const colorInputs = document.querySelectorAll('input[name="Color"]');
    colorInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const color = e.target.value.toLowerCase();
        this.updateImagesForColor(color);
      });
    });

    // Also listen for custom events
    document.addEventListener('variant:changed', (e) => {
      if (e.detail?.variant?.option1) {
        this.updateImagesForColor(e.detail.variant.option1.toLowerCase());
      }
    });
  }

  updateImagesForColor(color, isInitial = false) {
    // Normalize the color name for comparison
    const normalizedColor = this.normalizeColorName(color);
    
    // Hide all images first
    this.images.forEach(image => {
      image.style.display = 'none';
    });

    // Find all images for this color
    const colorImages = Array.from(this.images).filter(image => {
      const imgSrc = image.querySelector('img')?.src.toLowerCase() || '';
      const imgAlt = image.querySelector('img')?.alt.toLowerCase() || '';
      
      // Check both src and variant IDs
      const matchesColor = imgSrc.includes(normalizedColor);
      const variantIds = image.getAttribute('data-variant-id')?.split(',') || [];
      const matchesVariant = this.variantData.some(variant => 
        variant.option1.toLowerCase() === color.toLowerCase() &&
        variantIds.includes(variant.id.toString())
      );
      
      return matchesColor || matchesVariant;
    });

    // Show matching images
    colorImages.forEach(image => {
      image.style.display = 'block';
    });

    // Scroll to first image and update navigation
    if (colorImages.length > 0) {
      if (!isInitial) {
        this.scrollToImage(colorImages[0]);
      }
    }
    this.updateNavigationButtons();
  }

  normalizeColorName(color) {
    // Handle special cases for color names
    const colorMap = {
      'navy': 'blue',
      'burgundy': 'burgundy',
      // Add more color mappings if needed
    };
    return colorMap[color.toLowerCase()] || color.toLowerCase();
  }

  scrollToImage(image) {
    if (image && this.slider) {
      const index = Array.from(this.images).indexOf(image);
      if (index !== -1) {
        const scrollPosition = image.offsetWidth * index;
        this.slider.parentElement.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    }
  }

  updateNavigationButtons() {
    const visibleImages = Array.from(this.images).filter(
      img => img.style.display === 'block'
    );
    
    this.prevButton.style.opacity = visibleImages.length <= 1 ? '0.5' : '1';
    this.nextButton.style.opacity = visibleImages.length <= 1 ? '0.5' : '1';
    this.prevButton.style.pointerEvents = visibleImages.length <= 1 ? 'none' : 'auto';
    this.nextButton.style.pointerEvents = visibleImages.length <= 1 ? 'none' : 'auto';
  }
}

// Initialize gallery after DOM is fully loaded
window.addEventListener('load', () => {
  const galleries = document.querySelectorAll('.product-gallery-mobile');
  galleries.forEach(gallery => new ProductGalleryMobile(gallery));
});

// Also initialize on DOMContentLoaded for faster response
document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.product-gallery-mobile');
  galleries.forEach(gallery => new ProductGalleryMobile(gallery));
});

// Handle Shopify section updates
document.addEventListener('shopify:section:load', (event) => {
  const galleries = event.target.querySelectorAll('.product-gallery-mobile');
  galleries.forEach(gallery => new ProductGalleryMobile(gallery));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rival-guerrero-collection"] && !Shopify.designMode) return;
  try {
    
  const initializeRfxCollection = (section) => {
    if (!section || section.dataset.rfxReady === 'true') return;

    const cards = Array.from(section.querySelectorAll('[data-rfx-card]'));
    const modelButtons = Array.from(section.querySelectorAll('[data-rfx-model]'));
    const weightButtons = Array.from(section.querySelectorAll('[data-rfx-weight]'));
    const galleries = Array.from(section.querySelectorAll('[data-rfx-gallery]'));
    const empty = section.querySelector('[data-rfx-empty]');
    const reset = section.querySelector('[data-rfx-reset]');
    const state = { model: 'all', weight: 'all' };
    const sliderInstances = new Map();
    const mobileViewport = window.matchMedia('(max-width: 767px)');

    const setButtonState = (buttons, activeValue, attribute) => {
      buttons.forEach((button) => {
        const isActive = button.dataset[attribute] === activeValue;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    };

    const syncGalleries = () => {
      if (!window.Swiper) return;

      if (mobileViewport.matches) {
        galleries.forEach((gallery) => {
          if (sliderInstances.has(gallery)) return;
          if (gallery.querySelectorAll('.swiper-slide').length < 2) return;

          const pagination = gallery.querySelector('.swiper-pagination');
          const slider = new window.Swiper(gallery, {
            slidesPerView: 1,
            speed: 220,
            threshold: 7,
            touchAngle: 45,
            touchEventsTarget: 'container',
            touchStartPreventDefault: false,
            followFinger: true,
            allowTouchMove: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.25,
            rewind: true,
            resistanceRatio: 0.35,
            preventClicks: true,
            preventClicksPropagation: true,
            preventInteractionOnTransition: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            a11y: {
              enabled: true
            },
            pagination: pagination
              ? {
                  el: pagination,
                  clickable: true
                }
              : undefined
          });

          sliderInstances.set(gallery, slider);
        });
      } else {
        sliderInstances.forEach((slider) => slider.destroy(true, true));
        sliderInstances.clear();
      }
    };

    const render = () => {
      let visible = 0;

      cards.forEach((card) => {
        const modelMatch = state.model === 'all' || card.dataset.model === state.model;
        const weightMatch = state.weight === 'all' || card.dataset.weight === state.weight;
        const shouldShow = modelMatch && weightMatch;
        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      setButtonState(modelButtons, state.model, 'rfxModel');
      setButtonState(weightButtons, state.weight, 'rfxWeight');
      sliderInstances.forEach((slider) => slider.update());
    };

    modelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.model = button.dataset.rfxModel;
        render();
      });
    });

    weightButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.weight = button.dataset.rfxWeight;
        render();
      });
    });

    if (reset) {
      reset.addEventListener('click', () => {
        state.model = 'all';
        state.weight = 'all';
        render();
      });
    }

    mobileViewport.addEventListener('change', syncGalleries);
    section.dataset.rfxReady = 'true';
    syncGalleries();
    render();
  };

  document.querySelectorAll('[data-rfx-collection]').forEach(initializeRfxCollection);

  document.addEventListener('shopify:section:load', (event) => {
    const loadedSection = event.target.matches('[data-rfx-collection]')
      ? event.target
      : event.target.querySelector('[data-rfx-collection]');
    initializeRfxCollection(loadedSection);
  });

  } catch(e) { console.error(e); }
})();
})();
